import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function MaintenanceItemCard({ item }) {
  const location = useLocation();
  const [isParentElement, setIsParentElement] = useState(true);
  const isMaintenanceItemPage = location.pathname === "/MaintenanceItems";

  return (
    <>
      <div className="maintenance-item-card card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h3 className="mt-2"> {item?.name}</h3>
          <div className="rounded-circle bg-100 accent-200">
            <i className="fa-solid fa-bolt"></i>
          </div>
        </div>
        <div className="maintenance-item-info card-body">
          <p className="text-100"> {item?.description}</p>

          <div className="row align-items-center">
            <p className="col-5"> نوع الصيانة </p>
            <p className="col-1">:</p>
            <p className="col-5">{item?.category}</p>
          </div>

          <div className="row align-items-center">
            <p className="col-5"> وقت الصيانة </p>
            <p className="col-1">:</p>
            <p className="col-5">{item?.estimated_duration}</p>
          </div>

          {item?.level == 1 && (
            <div className="row align-items-center">
              <p className="col-5"> عدد العناصر الفرعية </p>
              <p className="col-1">:</p>
              <p className="col-5">{item?.children?.length}</p>
            </div>
          )}

          {!isParentElement && (
            <div className="row align-items-center">
              <p className="col-5"> تابع لعنصر </p>
              <p className="col-1">:</p>
              <p className="col-5"> لوحة التحكم </p>
            </div>
          )}

          {isMaintenanceItemPage && (
            <div className="d-flex align-items-center justify-content-center gap-4 ">
              <Link className="btn btn-primary text-white" to={`/MaintenanceItems/MaintenanceItem/${item?.id}`}>
                العناصر الفرعية
              </Link>
              <Link className="btn btn-warning text-white" to={`/EditMaintenanceItem/${item?.id}`}>
                تعديل
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
